import axios from 'axios';

const api = axios.create({
//baseURL: 'http://localhost:5003',
baseURL: 'https://lightningpresort-3c0bfe3acad3.herokuapp.com',
  withCredentials: true,
});



api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && error.config.url !== '/user/login') {
      try {
        const response = await api.post('/refresh-token', {}, { withCredentials: true });
        if (response.status === 200) {
          console.log('Token refreshed');
          return api(error.config); // Retry the original request
        }
      } catch (refreshError) {
        console.error('Token refresh failed:', refreshError);
      
      }
    }
    return Promise.reject(error);
  }
);

export default api;